import { get, set, findIndex } from 'lodash';

const addSkuFilter = (gridProps) => {
    const newFiltersArray = get(gridProps, 'filters', []).concat([
        {
            field: 'product_sku',
            label: 'SKU',
            type: 'string',
        },
    ]);

    set(gridProps, 'filters', newFiltersArray);

    return gridProps;
};

export const customGridAddSkuData = (gridProps) => addSkuFilter(gridProps);

export const customGridDataWarehouseLabel = (gridProps) => {
    const newData = addSkuFilter(gridProps);

    set(
        newData,
        'columns',
        newData.columns.map((column) => {
            if (column.field === 'fulfillFrom.label') {
                set(column, 'label', 'Pickup Store');
            }
            return column;
        }),
    );

    return newData;
};

export const customFinalizedGridConfig = (gridProps) => {
    const newData = customGridDataWarehouseLabel(gridProps);

    if (!newData.customFields) newData.customFields = {};
    if (!newData.customFields.visibleFields) newData.customFields.visibleFields = [];
    newData.customFields.visibleFields.push('picked_up_date');
    newData.customFields.startPosition = 6;

    return newData;
};

export const customPickGridConfig = (gridProps) => {
    const createdColIndex = findIndex(gridProps.columns, ['field', 'created_at']);
    if (createdColIndex >= 0) {
        set(gridProps, `columns[${createdColIndex}]sortDir`, 'asc');
    }
    return gridProps;
};
